import React from 'react';

import { Flex } from '../../components/common/atom/Layout';
import { Text } from '../../components/common/atom/Text';

const ItemDescriptionView = ({ descriptions, items }) => {
  return (
    <Flex column padding="0.313rem 0" alignItems="stretch">
      {descriptions.map((description, index) => (
        <Text key={index} size={12} color="brownGrey">
          {description}
        </Text>
      ))}
      {items === undefined || items.shippingToAffiliate
        ? ''
        : items.additionalInfo.infoType === 'conversion' && (
            <>
              <Text size={12} color="brownGrey">
                분석 완료기한 : {items && items.convertedConversionDeadline}
              </Text>
              {items.shipmentRequired && 
                <Text size={12} color="brownGrey">
                  배송 시작기한 : {items && items.convertedDeliveryDeadline}
                </Text>
              }
            </>
          )}
    </Flex>
  );
};

export default React.memo(ItemDescriptionView);
